import { useRef, useState } from "react";

export default function useSessionStorage(sessionKey: string) {

  const storage = useRef<typeof sessionStorage>(
      typeof window === 'undefined'
          ? {  getItem: () => null, removeItem: () => {}, setItem: () => {} } as any
          : window.sessionStorage
  );

  const [value, setValue] = useState(storage.current.getItem(sessionKey));

  const setter = useRef((nextValue: null | string) => {
      if (nextValue === null) {
          storage.current.removeItem(sessionKey);
      } else {
          storage.current.setItem(sessionKey, nextValue);
      }
      setValue(nextValue);
  });

  return [value, setter.current] as [
      null | string,
      typeof setter.current,
  ];
}
